<template>
    <b-container>
        <div v-if="buildings.length > 0">
            <b-row class="mt-4">
                <b-col sm="4">
                    <b-form-select v-model="building" :options="buildings" v-on:change="OnBuildingClick"></b-form-select>
                    <div class="text-danger" v-if="!$v.building.required && $v.building.$dirty">
                        {{ $t("info.required") }}
                    </div>
                </b-col>
            </b-row>

            <div v-if="building && !existingTeamBuilding">
                <b-row>
                    <b-col sm="6" class="mt-4">
                        <v-select v-model="teamSelect" :options="teamsGroup" @search="searchGroup"
                            :placeholder="$t('action.chooseGroup')" label="displayName">
                        </v-select>
                    </b-col>
                </b-row>
            </div>

            <b-row v-if="building" class="mt-4">
                <b-col>
                    <b-alert show variant="info">
                        <p class="pt-2">
                            <strong>{{ $t("label.currentGroup") }} : </strong>{{
                                existingTeamBuilding
                                ? existingTeamBuilding.GroupName
                                : $t("label.noAssociation")
                            }}
                        </p>
                        <p v-if="existingTeamBuilding">
                            <a :href="getPlanneUrl(existingTeamBuilding)" target="_blank">Plan url</a>
                        </p>
                        <div v-if="teamSelect">
                            <p>
                                <strong>{{ $t("label.newGroup") }} : </strong>{{
                                    buildingMatch
                                    ? $t("info.groupAlreadyExist")
                                    : teamSelect.displayName
                                }}
                            </p>
                            <ul>
                                <li><strong>createdDateTime</strong> : {{ teamSelect.createdDateTime }}</li>
                                <li><strong>mail</strong>: {{ teamSelect.mail }}</li>
                                <li><b-button variant="link" @click="openmodal('getMemberOf')">{{
                                    $t("action.getMemberOf") }}</b-button></li>
                                <li><a :href="getPlanneUrl(teamSelect)" target="_blank">Plan url</a></li>
                            </ul>
                        </div>

                        <b-form-group v-if="building.Language" label="Language" v-slot="{ ariaDescribedby }">
                            <b-form-radio-group id="radio-group-2" :aria-describedby="ariaDescribedby"
                                name="radio-sub-component" v-model="building.Language">
                                <b-form-radio :aria-describedby="ariaDescribedby" name="french" value="fr">{{
                                    $t("label.french") }}</b-form-radio>
                                <b-form-radio :aria-describedby="ariaDescribedby" name="english" value="en">{{
                                    $t("label.english") }}</b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>
                    </b-alert>
                </b-col>
            </b-row>

            <b-row v-if="groupAssociateToOtherBuilding">
                <b-col>
                    <b-alert show variant="danger">
                        <p>
                            {{ $t("info.existingTeamForBuilding") }}
                        </p>
                    </b-alert>
                </b-col>
            </b-row>

            <div v-if="existingTeamBuilding">
                <b-button class="mt-4" variant="outline-danger" @click="removeAssociation()">{{ $t("action.remove")
                }}</b-button>
            </div>
            <div v-if="(teamSelect || existingTeamBuilding) && building">
                <b-row>
                    <b-col>
                        <b-button class="mt-4" variant="success" :disabled="disabled" @click="getGroupPlan()">{{
                            $t("action.update") }}</b-button>
                    </b-col>
                </b-row>
            </div>
        </div>

        <b-modal id="getMemberOf" :title="$t('title.confirmation')" hide-footer>
            <ul>
                <li v-for="item in memberOf" :key="item.id">
                    {{ item.displayName }}
                </li>
            </ul>
        </b-modal>

        <div v-if="spinner" class="text-center">
            <b-spinner style="width: 3rem; height: 3rem" class="spinner" variant="success" label="Spinning"
                disabled="labelStatus"></b-spinner>
        </div>

        <div v-if="success" class="pt-4">
            <b-alert show variant="success">
                <p>{{ $t("info.successgeneric") }}</p>
            </b-alert>
        </div>

        <div v-if="error" class="pt-4">
            <b-alert show variant="danger">
                <p>{{ error }}</p>
            </b-alert>
        </div>
    </b-container>
</template>
  
<script>
import axios from "axios";
import { globalF } from "../../Helpers";
import { required } from "vuelidate/lib/validators";
import moment from "moment";

export default {
    mixins: [globalF],
    props: ["modalid"],
    data() {
        return {
            success: false,
            immeuble: [],
            error: "",
            spinner: false,
            disabled: false,
            rawData: [],
            buildings: [],
            building: null,
            sortBy: "displayName",
            sortDesc: false,
            perPage: 10,
            currentPage: 1,
            search: "",
            options: [
                { value: 10, text: "10" },
                { value: 25, text: "25" },
                { value: 50, text: "50" },
                { value: 100, text: "100" },
            ],
            teamSelect: null,
            existingTeamBuilding: null,
            groupAssociateToOtherBuilding: false,
            newGroupName: "",
            teamPlan: null,
            teamBucket: null,
            userBuildingGraph: [],
            buildingMatch: null,
            memberOf: [],
            existingBucket: [],
            bucketList: [],
            groupPlans: []
        };
    },
    validations() {
        return {
            building: {
                required,
            },
        };
    },
    watch: {
      teamSelect: function (val) {
        if (val) {
          this.getAllGroupPlan(val.id);
        }
      }
    },
    mounted() {
        this.getBuildingList();
    },
    computed: {
        url: function () {
            return this.getUrl();
        },
        rows() {
            return this.items.length;
        },
        items: function () {
            let mydatalist = this.teamsGroup;
            let search = this.search.toLowerCase();
            return mydatalist.filter((p) => {
                let displayName = p.displayName ? p.displayName : "";
                let email = p.mail ? p.mail : "";
                let createdDateTime = p.createdDateTime ? p.createdDateTime : "";

                return (
                    displayName.toString().toLowerCase().includes(search) ||
                    email.toString().toLowerCase().includes(search) ||
                    createdDateTime.toLowerCase().includes(search)
                );
            });
        },
        myfields: function () {
            return [
                {
                    key: "displayName",
                    sortable: true,
                    label: this.$t("label.nameOfTheGroup"),
                },
                { key: "mail", sortable: true, label: this.$t("label.email") },
                {
                    key: "createdDateTime",
                    sortable: true,
                    label: this.$t("label.date"),
                    formatter: (value) => {
                        return value ? moment(value).format("YYYY-MM-DD HH:mm:ss") : "";
                    },
                },
                { key: "details", label: this.$t("label.edit") },
            ];
        },
    },
    methods: {
        openmodal: function (modalid) {
            let token = this.getGlobalData("accessToken");
            let groupId = this.teamSelect.id;
            this.getMemberOf(token, groupId, modalid);

        },
        searchGroup(searchText) {
            if (searchText) {
                let token = this.getGlobalData("accessToken");
                this.spinner = true;
                let graphEndpoint = `https://graph.microsoft.com/v1.0/groups?$filter=startswith(displayName,'${searchText}')&$count=true&$top=10`;
                axios
                    .get(graphEndpoint, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                            ConsistencyLevel: "eventual",
                        },
                    })
                    .then((response) => {
                        this.spinner = false;
                        if (response.status === 200) {
                            this.teamsGroup = response.data.value;
                        } else {
                            this.error = this.$t("info.errorgeneric");
                        }
                    })
                    .catch(() => {
                        this.error = this.$t("info.errorgeneric");
                        this.spinner = false;
                    });
            }
        },
        getMemberOf(token, groupId, modalid) {
            this.spinner = true;
            let graphEndpoint = `https://graph.microsoft.com/v1.0/groups/${groupId}/members`;
            axios
                .get(graphEndpoint, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                        ConsistencyLevel: "eventual",
                    },
                })
                .then((response) => {
                    this.spinner = false;
                    let membersList = response.data.value;
                    this.memberOf = membersList;
                    this.$bvModal.show(modalid);
                })
                .catch(() => {
                    this.spinner = false;
                    this.error = this.$t("info.errorgeneric");
                });
        },
        getBuildingList() {
            this.spinner = true;
            let urls = this.$store.getters.getUrlsList;
            let url = urls[process.env.VUE_APP_WHERE].json;

            let promise = this.validateToken();
            promise.then(() => {
                axios
                    .post(
                        url,
                        { request: "getAllGroups" },
                        { headers: { "Content-Type": "application/json" } }
                    )
                    .then((response) => {
                        this.spinner = false;
                        this.bucketList = response.data.bucketList;
                        this.teamsBuilding = response.data.teamBuildings;
                        let buildings = this.setProvinceAndLanguage(
                            response.data.buildings,
                            response.data.immeuble,
                            response.data.teamBuildings
                        );

                        this.buildings = this.mapBuildingForBootstrapSelect(buildings);

                        this.formatRawData();
                    })
                    .catch(() => {
                        this.spinner = false;
                        this.error = this.$t("info.errorgeneric");
                    });
            });
        },
        mapBuildingForBootstrapSelect(buildings) {
            let mapBuilding = buildings.map((b) => {
                return {
                    text: b.NOMDIV,
                    value: b,
                };
            });

            mapBuilding.sort(function (a, b) {
                if (a.text < b.text) {
                    return -1;
                }
                if (a.text > b.text) {
                    return 1;
                }
                return 0;
            });

            mapBuilding.unshift({
                text: this.$t("label.properties"),
                value: null,
            });

            return mapBuilding;
        },
        setProvinceAndLanguage(buildings, immeubles, groupBuildings) {
            return buildings.map((b) => {
                b.Language = "en";
                b.Province = "NA";
                let groupBuilding = groupBuildings.find((g) => g.IdBuilding === b.Id);
                if (groupBuilding) {
                    b.Language = groupBuilding.Language;
                    b.Province = groupBuilding.Province;
                }
                else {
                    let immeuble = immeubles.find((i) => i.IdBuilding === b.Id);
                    if (immeuble && immeuble.Province) {
                        b.Language = this.getDefaultLg(immeuble);
                        b.Province = immeuble.Province;
                    }
                }
                return b;
            });
        },
        getDefaultLg(immeuble) {
            let lg = "en";
            if (immeuble) {
                let prov = immeuble.Province;
                prov.replace(/[\W_]+/g, " ");
                if (
                    prov.toLowerCase() === "québec" ||
                    prov.toLowerCase() === "qc" ||
                    prov.toLowerCase() === "quebec"
                ) {
                    lg = "fr";
                }
            }
            return lg;
        },
        resetTable: function () {
            this.search = "";
        },
        getGroupsWithTeams(graphEndpoint, token) {
            this.error = "";
            this.spinner = true;

            axios
                .get(graphEndpoint, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                })
                .then((response) => {
                    if (response.status === 200) {
                        let nextLink = response.data["@odata.nextLink"];
                        this.rawData.push(response.data.value);

                        if (nextLink) {
                            this.getGroupsWithTeams(nextLink, token);
                        } else {
                            this.getBuildingList();
                        }
                    } else {
                        this.error = this.$t("info.errorgeneric");
                    }
                })
                .catch(() => {
                    this.spinner = false;
                    this.error = this.$t("info.errorgeneric");
                });
        },
        formatRawData: function () {
            let flatTable = this.rawData.flat(); //Distribution List
            let teamsBuilding = this.teamsBuilding;
            let filterTable = flatTable.filter((f) => {
                return !teamsBuilding.find((t) => t.TeamId === f.id);
            });

            this.teamsGroup = filterTable.map((f) => {
                f.variant = "outline-success";
                return f;
            });
        },
        OnBuildingClick: function () {
            this.error = "";
            this.disabled = false;
            this.success = false;
            this.groupAssociateToOtherBuilding = false;
            this.existingTeamBuilding = null;
            this.teamSelect = null;
            this.memberOf = [];
            this.getGroupAssociatedToBuilding();
        },
        getGroupAssociatedToBuilding() {
            this.existingTeamBuilding = this.teamsBuilding.find(
                (t) => t.IdBuilding === this.building.Id
            );
        },
        chooseGroup: function (group) {
            let tableInfo = this.teamsGroup;
            let teamSelect = this.teamSelect;
            let groupToAssign = null;

            this.teamsGroup = tableInfo.map((g) => {
                if (teamSelect) {
                    if (g.id === teamSelect.id) {
                        g.variant = "outline-success";
                        groupToAssign = null;
                    } else {
                        if (g.id === group.id) {
                            g.variant = "success";
                            groupToAssign = group;
                        } else {
                            g.variant = "outline-success";
                        }
                    }
                } else {
                    if (g.id === group.id) {
                        g.variant = "success";
                        groupToAssign = group;
                    } else {
                        g.variant = "outline-success";
                    }
                }

                return g;
            });

            this.teamSelect = groupToAssign;
            this.buildingMatch = null;

            if (this.teamSelect) {
                this.buildingMatch = this.teamsBuilding.find(
                    (t) =>
                        t.GroupId === this.teamSelect.id &&
                        t.IdBuilding === this.building.Id
                );
            }
        },
        associateGroupToBuilding: function (plan) {

            if (!this.existingTeamBuilding) {
                let obj = {
                    request: "updateTeam",
                    idBuilding: this.building.Id,
                    buildingName: this.building.NOMDIV,
                    province: this.building.Province,
                    language: this.building.Language,
                    teamId: this.teamSelect.id,
                    teamName: this.teamSelect.displayName,
                    plan: plan
                };

                axios
                    .post(this.url, obj, {
                        headers: { "Content-Type": "application/json" },
                    })
                    .then((response) => {
                        this.spinner = false;
                        if (response.data === "ExistingTeamForBuilding") {
                            this.groupAssociateToOtherBuilding = true;
                            this.disabled = false;
                        } else {
                            this.$bvModal.hide(this.modalid);
                        }
                    })
                    .catch(() => {
                        this.spinner = false;
                        this.error = this.$t("info.errorgeneric");
                    });
            }
        },
        removeAssociation() {
            this.error = "";
            this.spinner = true;

            let obj = {
                request: "removeAssociation",
                id: this.existingTeamBuilding.Id,
            };

            axios
                .post(this.url, obj, {
                    headers: { "Content-Type": "application/json" },
                })
                .then(() => {
                    this.spinner = false;
                    this.$bvModal.hide(this.modalid);
                })
                .catch(() => {
                    this.spinner = false;
                    this.error = this.$t("info.errorgeneric");
                });
        },
        getAllGroupPlan(groupId) {
            let token = this.getGlobalData("accessToken");
            this.error = "";
            this.spinner = true;
            let graphEndpoint = `https://graph.microsoft.com/v1.0/groups/${groupId}/planner/plans`;
            axios.get(graphEndpoint, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }).then((result) => {
                this.spinner = false;
                let plans = result.data.value;
                if (plans.length > 0) {
                    this.groupPlans = plans;
                }
            }).catch(() => {
                this.spinner = false;
                this.disabled = false;
                this.error = this.$t("info.errorgeneric");
            });
        },
        getGroupPlan() {
            let groupId = this.existingTeamBuilding ? this.existingTeamBuilding.GroupId : this.teamSelect.id;
            let token = this.getGlobalData("accessToken");
            this.error = "";
            this.spinner = true;
            this.disabled = true;
            let graphEndpoint = `https://graph.microsoft.com/v1.0/groups/${groupId}/planner/plans`;
            axios.get(graphEndpoint, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }).then((result) => {
                let plans = result.data.value;
                if (plans.length > 0) {
                    let plan = plans[0];
                    this.getPlanBucket(token, plan);
                }
                else {
                    this.disabled = false;
                    this.spinner = false;
                    this.error = 'There is no plan for this group. A member of the group must create a plan.'
                }
            }).catch(() => {
                this.spinner = false;
                this.disabled = false;
                this.error = this.$t("info.errorgeneric");
            });
        },
        getPlanBucket(token, plan) {
            //GET /planner/plans/{plan-id}/buckets
            let planId = plan.id;
            let graphEndpoint = `https://graph.microsoft.com/v1.0/planner/plans/${planId}/buckets`;
            axios.get(graphEndpoint, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }).then((result) => {
                this.spinner = false;
                this.existingBucket = result.data.value;
                this.addPlanBucketToGroup(plan);
            }).catch(() => {
                this.spinner = false;
                this.disabled = false;
                this.error = this.$t("info.errorgeneric");
            });
        },
        addPlanBucket(token, body) {
            let graphEndpoint = `https://graph.microsoft.com/v1.0/planner/buckets`;
            return axios.post(graphEndpoint, body, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
        },
        addPlanBucketToGroup(plan) {
            let taskItemList = this.bucketList;
            let existingBucket = this.existingBucket;
            let token = this.getGlobalData("accessToken");
            let requestBuckets = [];

            for (let j = 0; j < taskItemList.length; j++) {
                let taskItem = taskItemList[j];
                let taskItemName = this.building.Language === 'fr' ? taskItem.fr : taskItem.en;
                let found = existingBucket.find(e => e.name === taskItemName);
                if (!found && plan.id) {
                    let obj = {
                        "name": taskItemName,
                        "planId": plan.id,
                        "orderHint": " !"
                    }
                    requestBuckets.push(this.addPlanBucket(token, obj));
                }
            }

            if (requestBuckets.length > 0) {
                Promise.allSettled(requestBuckets).then((results) => {
                    let errorList = results.filter((r) => r.status === "rejected");
                    if (errorList.length > 0) {
                        this.errorList.push(errorList);
                        this.logError(errorList);
                        this.spinner = false;
                        this.disabled = false;
                    }
                    else {
                        this.associateGroupToBuilding(plan);
                    }
                });
            }
            else {
                this.associateGroupToBuilding(plan);
            }
        },
        logError(errorList) {
            let obj = {
                request: "logError",
                jobName: "AddBucketToGroup",
                errorList: errorList,
            };
            axios
                .post(this.url, obj, {
                    headers: { "Content-Type": "application/json" },
                })
                .then(() => {
                    this.spinner = false;
                    this.disabled = false;
                })
                .catch(() => {
                    this.spinner = false;
                    this.disabled = false;
                    this.error = this.$t("info.errorgeneric");
                });
        },
        getPlanneUrl(group) {
           let tenantId = this.$store.getters.getTenantId;
           let planId = "";
           if (this.existingTeamBuilding) {
            planId = group.PlanId;
           }
           else {
            if (this.groupPlans && this.groupPlans.length > 0) {
                let plan = this.groupPlans[0];
                planId = plan.id;
            }
           }
            
            return `https://planner.cloud.microsoft/webui/v1/plan/${planId}?tid=${tenantId}`;
        }
    },
};
</script>
  